@if (showCard()) {
  @if (hideStyle()) {
    <div class="simple-help-case-card">
      <ng-container *ngTemplateOutlet="helpCaseInfo"></ng-container>
    </div>
  } @else {
    <va-card class="help-case-card">
      <ng-container *ngTemplateOutlet="helpCaseInfo"></ng-container>
    </va-card>
  }
}

<ng-template #helpCaseInfo>
  @if (helpCase().id === 'liveChat') {
    <div class="help-case-card_inner-container" onclick="$zopim.livechat.window.show()">
      <ng-container *ngTemplateOutlet="helpCaseImg"></ng-container>
      <div class="help-name-container">
        <div class="help-name">
          {{ helpCase().name | translate }}
        </div>
      </div>
    </div>
  } @else {
    <div class="help-case-card_inner-container">
      <ng-container *ngTemplateOutlet="helpCaseImg"></ng-container>
      <div class="help-name-container">
        @if (phone) {
          <div class="help-name">
            {{ helpCase().name | translate }}
            <a href="tel:{{ phone }}">
              {{ phone | formatPhoneNumber: countryCode }}
            </a>
          </div>
        } @else {
          <div class="help-name">
            {{ helpCase().name | translate }}
            @if (helpCase().newBadge) {
              <glxy-badge [color]="'blue'" class="help-new-badge">
                {{ 'HELP_CENTER.NEW' | translate }}
              </glxy-badge>
            }
          </div>
          <div class="help-sub-title">
            {{ helpCase().subTitle | translate }}
          </div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #helpCaseImg>
  <div [ngClass]="hideStyle() ? 'small-help-image-container' : 'help-image-container'">
    <div>
      <img [src]="getImageSrc(helpCase().image)" [alt]="helpCase().imageAlt" />
    </div>
  </div>
</ng-template>
